<template>
	<AlertMessage
		v-if="isShown"
		type="warning"
		class="live-updates-notice"
	>
		{{ message }}
		<template #action>
			<v-btn
				variant="outlined"
				@click="reloadPage"
			>
				<Renew16 />
				<span>Reload page</span>
			</v-btn>
		</template>
	</AlertMessage>
</template>

<script lang="ts">
import { defineComponent } from "vue";

import Renew16 from "@carbon/icons-vue/es/renew/16";

import AlertMessage from "@/components/Common/AlertMessage.vue";
import { useRealtimeStore } from "@/stores/realtime";

export default defineComponent({
	name: "LiveUpdatesNotice",
	components: { AlertMessage, Renew16 },
	setup() {
		return { realtimeStore: useRealtimeStore() };
	},
	computed: {
		isShown(): boolean {
			return this.realtimeStore.showPausedNotice || this.realtimeStore.showStoppedNotice;
		},
		message(): string {
			return this.realtimeStore.showStoppedNotice
				? "Live updates stopped. Reload the page to restart them."
				: "Live updates paused. Reload the page to restart them.";
		},
	},
	methods: {
		reloadPage(): void {
			window.location.reload();
		},
	},
});
</script>

<style lang="scss" scoped>
.alert-message.live-updates-notice {
	border-width: 0 0 var(--sgnl-border-width-1);
	border-radius: var(--sgnl-border-radius-0);
	padding-inline: calc(max(0px, (100% - var(--sgnl-container-1280)) / 2) + var(--sgnl-space-24));
}
</style>
